import React from 'react';

export function usePageVisibility(document = window.document) {
  const [isVisible, setIsVisible] = React.useState(!document.hidden);

  React.useEffect(() => {
    document.addEventListener(
      'visibilitychange',
      () => {
        setIsVisible(!document.hidden);
      },
      false
    );

    return () => {
      document.removeEventListener('visibilitychange', () => {
        setIsVisible(document.hidden);
      });
    };
  }, [document, setIsVisible]);

  return { isVisible };
}
